import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u></u>Injury Details Report</center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.groupID}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estateID}</div>
                    <div className="col"><b>Collection Point: </b>{searchData.division} </div>
                    <div className="col"><b>Search Date: </b> {searchData.searchDate}</div>
                </div>
                <div>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Reg No
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Name
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                WorkTypeID
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Operator
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Injury Type
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Remark
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                ApprovedBy
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Approved Date
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Reason
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                Status
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {reportData.map((row) => (
                                <TableRow key={row.workExceptionalDetailsID}>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.employeeCode == undefined ? '-' : row.employeeCode}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.firstName == undefined ? '-' : row.firstName}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.workTypeID == undefined ? '-' : row.workTypeID === 1 ? 'Sundry' : 'Plucking'}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.operatorName == undefined ? '-' : row.operatorName}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.attackTypeName == undefined ? '-' : row.attackTypeName}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.remark == undefined ? '-' : row.remark }
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.approvedManagerName == undefined ? '-' : row.approvedManagerName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.approvedDate == undefined ? '-' : new Date(row.approvedDate).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.reason == undefined ? '-' : row.reason}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.statusID == undefined ? '-' : row.statusID=== 1 ? "New" : row.statusID === 2 ? "Approved" : row.statusID === 3 ? "Rejected" : "Rejected"}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}
